import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import DatePicker from "react-datepicker";
import Footer from "../utils/Footer";
import Header from "../utils/Header";
import Maps from "../utils/Maps.js";
import API_BASE_URL from "../../config.js";
import Swal from 'sweetalert2';
import getDetailPrice from "../../services/getDetailPrice.js";
import Cancelar from "../../assets/Cancelar.png"
import fechas from "../../assets/Llegada salida.png";
import huespedes from "../../assets/Huespedes.png";
import iconLetoh from "../../assets/iconLetoh.png"

import availability from "../../services/availability.js"

const ListingDetail = () => {


  const { listingId } = useParams();
  const [listing, setListing] = useState(null);
  const [showAll, setShowAll] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isAvailable, setAvailable] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const [searchParams] = useSearchParams(); // Inicializa el hook
  const [checkIn, setCheckIn] = useState(searchParams.get("checkIn"));
  const [checkOut, setCheckOut] = useState(searchParams.get("checkOut"));
  // const [guests, setGuests] = useState(searchParams.get("guests") ?? 1);
  // const [guests, setGuests] = useState(Number(searchParams.get("guests") || 1));
  const [guests, setGuests] = useState(
    Math.max(1, Number(searchParams.get("guests")) || 1)
  );

  const [dateRange, setDateRange] = useState([null, null]);
  const [start_Date, end_Date] = dateRange || ["", ""];


  // // const checkIn = searchParams.get("checkIn");
  // const checkOut = searchParams.get("checkOut");
  // const guests = searchParams.get("guests");
  const [openCalendar, setOpenCalendar] = useState(false);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");

  const [totalPrice, setTotalPrice] = useState(0);
  const [baseRate, setBaseRate] = useState(0);
  const [cleanFee, setCleanFee] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [days, setDays] = useState(0);

  const handleRedirect = () => {
    navigate(`/confirm/${listingId}?checkIn=${encodeURIComponent(checkIn)}&checkOut=${encodeURIComponent(checkOut)}&guests=${encodeURIComponent(guests)}&firstName=${encodeURIComponent(firstName)}&lastName=${encodeURIComponent(lastName)}&email=${encodeURIComponent(email)}&totalPrice=${encodeURIComponent(Math.ceil(totalPrice))}&discount=${encodeURIComponent(Math.ceil(discount))}`);
  };

  const handleValidation = () => {
    // Verificar que el nombre no esté vacío
    if (!firstName.trim()) {
      Swal.fire({
        imageUrl: Cancelar,
        imageWidth: 80,
        imageHeight: 80,
        title: 'Nombre requerido',
        text: 'Por favor, ingresa tu nombre.',
        timer: 5000,
        timerProgressBar: true,
        showConfirmButton: true,
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#1F4F51',
        customClass: {
          confirmButton: "bg-[#1F4F51] hover:bg-[#17403F] text-white font-semibold py-2 px-6 rounded-md w-40",
        },
      });
      return false;
    }

    // Verificar que el apellido no esté vacío
    if (!lastName.trim()) {
      Swal.fire({
        imageUrl: Cancelar,
        imageWidth: 80,
        imageHeight: 80,
        title: 'Apellido requerido',
        text: 'Por favor, ingresa tu apellido.',
        timer: 5000,
        timerProgressBar: true,
        showConfirmButton: true,
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#1F4F51',
        customClass: {
          confirmButton: "bg-[#1F4F51] hover:bg-[#17403F] text-white font-semibold py-2 px-6 rounded-md w-40",
        },
      });
      return false;
    }

    // Verificar que el correo electrónico no esté vacío y tenga formato válido
    if (!email.trim()) {
      Swal.fire({
        imageUrl: Cancelar,
        imageWidth: 80,
        imageHeight: 80,
        title: 'Correo requerido',
        text: 'Por favor, ingresa tu correo electrónico.',
        timer: 5000,
        timerProgressBar: true,
        showConfirmButton: true,
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#1F4F51',
        customClass: {
          confirmButton: "bg-[#1F4F51] hover:bg-[#17403F] text-white font-semibold py-2 px-6 rounded-md w-40",
        },
      });
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      Swal.fire({
        imageUrl: Cancelar,
        imageWidth: 80,
        imageHeight: 80,
        title: 'Correo inválido',
        text: 'Por favor, ingresa un correo electrónico válido.',
        timer: 5000,
        timerProgressBar: true,
        showConfirmButton: true,
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#1F4F51',
        customClass: {
          confirmButton: "bg-[#1F4F51] hover:bg-[#17403F] text-white font-semibold py-2 px-6 rounded-md w-40",
        },
      });
      return false;
    }

    return true; // Todo es válido
  };

  const handleReservation = async () => {
    if (handleValidation()) {
      try {
        handleRedirect()
      } catch (error) {
        console.error("Error en la reservación:", error);
      }
    }
  };
  const handleDates = () => {
    if (!start_Date || !end_Date) {
      Swal.fire({
        imageUrl: Cancelar,
        imageWidth: 80,
        imageHeight: 80,
        title: 'Fechas requeridas',
        text: 'Por favor, selecciona las fechas de llegada y salida.',
        timer: 5000,
        timerProgressBar: true,
        showConfirmButton: true,
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#1F4F51',
        customClass: {
          confirmButton: "bg-[#1F4F51] hover:bg-[#17403F] text-white font-semibold py-2 px-6 rounded-md w-40",

        },
      });
      return false;
    }
    if (end_Date < start_Date) {
      Swal.fire({
        imageUrl: Cancelar,
        imageWidth: 80,
        imageHeight: 80,
        title: 'Fechas inválidas',
        text: 'La fecha de salida no puede ser anterior a la de llegada.',
        timer: 5000,
        timerProgressBar: true,
        showConfirmButton: true,
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#1F4F51',
        customClass: {
          confirmButton: "bg-[#1F4F51] hover:bg-[#17403F] text-white font-semibold py-2 px-6 rounded-md w-40",
        }
      });
      return false;
    }
    if (end_Date.getTime() == start_Date.getTime()) {
      Swal.fire({
        imageUrl: Cancelar,
        imageWidth: 80,
        imageHeight: 80,
        title: 'Fechas inválidas',
        text: 'La fecha de salida no puede ser igual a la de llegada.',
        timer: 5000,
        timerProgressBar: true,
        showConfirmButton: true,
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#1F4F51',
        customClass: {
          confirmButton: "bg-[#1F4F51] hover:bg-[#17403F] text-white font-semibold py-2 px-6 rounded-md w-40",
        }
      });
      return false;
    }
    if (!guests) {
      Swal.fire({
        imageUrl: Cancelar,
        imageWidth: 80,
        imageHeight: 80,
        title: 'Número de huéspedes',
        text: 'Por favor, selecciona el número de huéspedes.',
        timer: 5000,
        timerProgressBar: true,
        showConfirmButton: true,
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#1F4F51',
        customClass: {
          confirmButton: "bg-[#1F4F51] hover:bg-[#17403F] text-white font-semibold py-2 px-6 rounded-md w-40",

        },
      });
      return false;
    }
    return true;
  };
  const handleClick = async () => {
    if (handleDates()) {
      try {
        const data = {
          "listingId": listingId,
          "start_date": checkIn,
          "end_date": checkOut
        };
        Swal.fire({
          title: 'Buscando disponibilidad...',
          text: 'Por favor, espere mientras se procesa su solicitud.',
          allowOutsideClick: false, // Prevent closing by clicking outside
          showConfirmButton: false, // Hide the confirmation button
          didOpen: () => {
            Swal.showLoading(); // Show the built-in loading spinner
          }
        });
        const response = await availability(data);
        if (response.status == 200) {
          setAvailable(true)
          navigate(`/listings/${listingId}?city=${encodeURIComponent(listing.city)}&checkIn=${encodeURIComponent(checkIn)}&checkOut=${encodeURIComponent(checkOut)}&guests=${encodeURIComponent(guests)}`);
          fetchPriceDetails()
          Swal.close();
        }
        else {
          setAvailable(false)
          Swal.fire({
            imageUrl: Cancelar,
            imageWidth: 80,
            imageHeight: 80,
            title: 'Fechas no disponible',
            text: 'Por favor, cambia las fechas o verifica en el buscador principal la disponibilidad de nuestros alojamientos para tus fechas específicas',
            timer: 9000,
            timerProgressBar: true,
            showConfirmButton: true,
            confirmButtonText: 'Entendido',
            confirmButtonColor: '#1F4F51',
            customClass: {
              confirmButton: "bg-[#1F4F51] hover:bg-[#17403F] text-white font-semibold py-2 px-6 rounded-md w-40",

            },
          });
        }

      } catch (error) {
        console.error("Fechas no disponibles:", error);
        setAvailable(false)
        Swal.fire({
          imageUrl: Cancelar,
          imageWidth: 80,
          imageHeight: 80,
          title: 'Fechas no disponible',
          text: 'Por favor, cambia las fechas o verifica en el buscador principal la disponibilidad de nuestros alojamientos para tus fechas específicas',
          timer: 9000,
          timerProgressBar: true,
          showConfirmButton: true,
          confirmButtonText: 'Entendido',
          confirmButtonColor: '#1F4F51',
          customClass: {
            confirmButton: "bg-[#1F4F51] hover:bg-[#17403F] text-white font-semibold py-2 px-6 rounded-md w-40",

          },
        });
        return false;

      }
    }
  };


  const fetchPriceDetails = async () => {
    try {
      // setLoading(true)
      const data = {
        "startingDate": checkIn,
        "endingDate": checkOut,
        "numberOfGuests": guests,
        "listingId": listingId,
      }

      const response = await getDetailPrice(data)

      if (response.status !== 200) {
        setLoading(false)
        throw new Error(`Error en la solicitud: ${response.status}`);
      }
      setTotalPrice(Math.ceil(response.data.totalPrice))
      setBaseRate(Math.ceil(response.data.basePrice))
      setDiscount(Math.ceil(response.data.couponDiscount))
      setCleanFee(Math.ceil(response.data.cleaningFee))
      setLoading(false)
      setAvailable(true)

      return response.data;
    } catch (error) {
      setLoading(false)
      console.error("Error al obtener detalles de precio:", error);
      return null;
    }
  };
  const FormattedDescription = ({ descripcion }) => {
    return (
      <div className="prose prose-sm text-gray-800">
        {descripcion
          ? descripcion.split('\n\n').map((parrafo, idx) => (
            <p key={idx}>
              {parrafo.split('\n').map((linea, i) => (
                <React.Fragment key={i}>
                  {linea}
                  <br />
                </React.Fragment>
              ))}
            </p>
          ))
          : <p>No hay descripción disponible.</p>
        }
      </div>
    );
  };


  useEffect(() => {
    fetch(`${API_BASE_URL}/listings/${listingId}/`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("No se pudo cargar el alojamiento.");
        }
        return response.json();
      })
      .then((data) => {
        setListing(data.result);


        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setError(err.message);
        setLoading(false);
      });
    fetchPriceDetails()
  }, [listingId]);

  useEffect(() => {
    const fecha1 = new Date(checkOut);
    const fecha2 = new Date(checkIn);
    const diferencia = (fecha1 - fecha2) / (1000 * 60 * 60 * 24);
    setDays(diferencia)
  }, [checkIn, checkOut])

  useEffect(() => {
    const valid = Boolean(
      checkIn &&
      checkIn.trim() !== "" &&
      checkIn.trim().toLowerCase() !== "null" &&
      checkOut &&
      checkOut.trim() !== "" &&
      checkOut.trim().toLowerCase() !== "null"
    );
    setAvailable(valid);
  }, []);

  if (loading) return <div className="fixed inset-0 bg-black bg-opacity-50 flex flex-col items-center justify-center z-50">
    <img src={iconLetoh} alt="Icono Letoh" className="w-20 h-20 mb-4 animate-pulse" />
  </div>
  if (error) return <p className="text-center text-red-500 mt-4">{error}</p>;
  if (!listing) return <p className="text-center text-gray-500 mt-4"></p>;

  const initialLimit = 10;

  const toggleShowAll = () => {
    setShowAll(!showAll);
  };


  const handleDateChange = (update) => {
    setDateRange(update);
    if (update[0] && update[1]) {
      const checkInDate = update[0].toISOString().split("T")[0];
      const checkOutDate = update[1].toISOString().split("T")[0];
      setCheckIn(checkInDate);
      setCheckOut(checkOutDate);
      setOpenCalendar(false);
    }
  };

  const amenitiesToShow = showAll
    ? listing.listingAmenities
    : listing.listingAmenities.slice(0, initialLimit);

  return (
    <div >
      <Header />
      <Swiper modules={[Navigation]} navigation loop className="w-full h-[30rem]">
        {listing.listingImages?.length > 0 ? (
          listing.listingImages.map((image, imgIndex) => (
            <SwiperSlide key={imgIndex}>
              <img src={image.url} alt={`Imagen ${imgIndex + 1}`} className="w-full h-full object-contain" />
            </SwiperSlide>
          ))
        ) : (
          <SwiperSlide>
            <img src="https://via.placeholder.com/300" alt="Imagen no disponible" className="w-full h-full object-contain" />
          </SwiperSlide>
        )}
      </Swiper>
      <div className="px-4 md:px-12 md:mx-8">
        <h2 className="text-2xl text-primaryP font-bold mt-4">{listing.name || "Nombre no disponible"}</h2>
        <p className="text-gray-500">{listing.city || "Ubicación no disponible"}</p>

        <div className="flex gap-1 text-sm text-gray-500">
          <p className="">{`${listing.personCapacity} ${listing.personCapacity == 1 ? "Huésped" : "Huéspedes"}`}</p>
          <span className="text-gray-400">|</span>
          <p className="">{`${listing.bedsNumber} ${listing.bedsNumber == 1 ? "Cama" : "Camas"}`}</p>
          <span className="text-gray-400">|</span>
          <p className="">{`${listing.bedroomsNumber} ${listing.bedroomsNumber == 1 ? "Habitación" : "Habitaciones"}`}</p>
          <span className="text-gray-400">|</span>
          <p className="">{`${listing.bathroomsNumber} ${listing.bathroomsNumber == 1 ? "Baño" : "Baños"}`}</p>
        </div>
        {/* <p className="text-gray-700 mt-2">{listing.description || "Sin descripción disponible."}</p> */}
        <FormattedDescription descripcion={listing.description} />


        <h2 className="text-2xl text-primaryP font-bold mt-4">Amenities</h2>
        <ul className="list-disc list-inside space-y-1">
          {amenitiesToShow.map((amenity) => (
            <li key={amenity.id} className="text-gray-700">
              {amenity.amenityName}
            </li>
          ))}
        </ul>
        {listing.listingAmenities.length > initialLimit && (
          <button
            onClick={toggleShowAll}
            className="mt-2 text-primaryP hover:underline focus:outline-none"
          >
            {showAll ? 'Ver menos' : 'Ver más'}
          </button>
        )}
        <h2 className="text-2xl text-primaryP font-bold mt-4">Ubicación</h2>
        <Maps lat={listing.lat} lng={listing.lng} listing={listing} />

        <div className="mt-6 py-4 text-gray-500">
          <h3 className="text-2xl text-primaryP font-bold">Haz una reservación</h3>
          {
            // (checkIn && checkIn.trim() !== "" && checkOut && checkOut.trim() !== "")
            (isAvailable)
              ?
              <div className="mx-auto w-full max-w-md p-4 bg-white shadow-lg rounded-lg">
                <p className="text-sm mb-0">
                  {listing.currencyCode} {listing.price ? `$${listing.price.toLocaleString('es-CO')} / noche (Dinámico)` : "Precio no disponible"}
                </p>
                <hr className="my-2" />
                <p className="text-sm mb-0  text-gray-400">Check in - Check out</p>
                <p className="text-sm pb-0">{checkIn} - {checkOut}</p>
                <hr className="my-2" />

                <p className="text-sm  mb-0">Número de huéspedes</p>
                <p className="text-sm pb-0">{guests} huéspedes</p>
                <hr className="my-2" />

                <label className="text-xs mb-0 text-gray-400">Nombre:</label>
                <input type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)}
                  className="appearance-none border-none bg-transparent text-sm text-gray-700 focus:outline-none w-full px-0"
                  name="first-name"
                  autoComplete="given-name"
                />
                <hr className="my-0" />
                <label className="text-xs mb-0 text-gray-400">Apellido:</label>
                <input type="text" value={lastName} onChange={(e) => setLastName(e.target.value)}
                  className="appearance-none border-none bg-transparent text-sm text-gray-700 focus:outline-none w-full px-0"
                  name="last-name"
                  autoComplete="family-name"
                />
                <hr className="my-0" />
                <label className="text-xs mb-0 text-gray-400">Correo electrónico:</label>
                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                  className="appearance-none border-none bg-transparent text-sm text-gray-700 focus:outline-none w-full px-0"
                  name="email"
                  autoComplete="email"
                />
                <hr className="my-0" />
                <hr className="mt-0 mb-4" />
                <p className="flex justify-between text-gray-600">
                  <span>{days} {days == 1 ? "noche" : "noches"}</span>
                  <span>${Math.ceil(baseRate).toLocaleString('es-CO')}</span>
                </p>
                <p className="flex justify-between text-gray-600">
                  <span>Servicio de limpieza</span>
                  <span>${Math.ceil(cleanFee).toLocaleString('es-CO')}</span>
                </p>
                {/* <div className="flex justify-between text-[red]">
                  <div>
                    <span>Descuento 5% </span>
                    <p className="text-xs">por comprar a través de nuestro portal</p>
                  </div>
                  <span>${Math.ceil(discount).toLocaleString('es-CO')}</span>
                </div> */}

                <p className="flex justify-between font-bold mt-2">
                  <span>Total</span>
                  <span>{listing.currencyCode} ${Math.ceil(totalPrice).toLocaleString('es-CO')}</span>
                </p>

                <button
                  onClick={handleReservation}
                  className="bg-[#1F4F51] w-full h-[45px] text-white font-bold rounded-md hover:bg-[#17403F] transition mt-4">
                  Continuar
                </button>
              </div>
              :
              <div>
                <div className="mx-auto w-full max-w-md p-4 bg-white shadow-lg rounded-lg">

                  <div className="flex items-center p-3 ">
                    <img src={fechas} className="h-6 md:mr-3" />
                    <DatePicker
                      selected={start_Date}
                      onChange={(update) => handleDateChange(update)}
                      startDate={start_Date}
                      endDate={end_Date}
                      selectsRange
                      shouldCloseOnSelect={true}
                      open={openCalendar}
                      onClickOutside={() => setOpenCalendar(false)}
                      onFocus={() => setOpenCalendar(true)}
                      minDate={new Date()}
                      placeholderText="Llegada / salida"
                      className=" border-none text-lg text-center p-0"
                    />

                  </div>

                  <div className="flex justify-center items-center py-3 border-t border-gray-300">
                    <img src={huespedes} className="h-6" />
                    <select
                      value={guests}
                      onChange={(e) => setGuests(e.target.value)}
                      className=" border-none text-lg text-center"
                    >
                      {[...Array(listing.personCapacity)].map((_, i) => (
                        <option key={i} value={i + 1} >
                          {i + 1} Huésped{i > 0 ? "es" : ""}
                        </option>
                      ))}
                    </select>
                  </div>
                  <button
                    onClick={handleClick}
                    className="bg-[#1F4F51] w-full h-[45px] text-white font-bold rounded-md hover:bg-[#17403F] transition mt-4"
                  >
                    Verifica disponibilidad
                  </button>
                </div>
              </div>
          }
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ListingDetail;